import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.element.dataset.action += " form:saving->subsection#startWaiting form:saved->subsection#stopWaiting"
    this.waiting = false
    this.attempted = false
  }

  submit(event) {
    if (this.waiting) {
      // cannot submit now, we're mid autosave elsewhere - record that an attempt was made
      event.preventDefault()
      this.attempted = true
    } else {
      // proceed as normal, submit
      this.attempted = false
    }
  }

  startWaiting() {
    // block submission due to autosaving elsewhere
    this.waiting = true
  }

  stopWaiting() {
    this.waiting = false

    if (this.attempted) {
      // time to retry the subsection navigation
      this.submitTarget.closest("form").requestSubmit()
    } else {
      // no attempt had been made, so no action required
    }
  }
}
